import { VideoSkinElement } from '../../presets/video/skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/default-video/register';

safeDefine(VideoSkinElement);
